import React, { useContext, useEffect, useState } from 'react';
import SelectionButtons from '../buttons/SelectionButtons';
import ColorListBox from '../ColorsListBody';
import SummaryBar from '../SummaryBar';
import { connect } from 'react-redux';
import RangeSlider from '../common/RangeSlider';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { WardrobeHeightContext } from '../../contexts/WardrobeHeightContext';
import { PriceContext } from '../../contexts/PriceContext';
import calculatePrice from '../../helpers/calculatePrice';
import { sendDataToExternalBasketOne, submitAjaxToBrw } from '../../store/actions/basket';
import PopUp from '../popup/PopUp';
import ShowBasketPopup from '../popup/ShowBasketPopup';

const getImageFromCanvas = async () => {
  return new Promise(resolve => {
    setTimeout(() => {
      const canvasRenderer = window.brwRenderer;
      canvasRenderer.render(window.brwScene, window.brwCamera);
      resolve(canvasRenderer.domElement.toDataURL());
    }, 100);
  });
};

const BuyWardrobeBodyConfigs = props => {
  const { wardrobeHulls, defaultFront, sendDataToExternalBasketOne, submitAjaxToBrw } = props;
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { wardrobeHeight, setWardrobeHeight } = useContext(WardrobeHeightContext);

  const [bodyState, setBodyState] = useState({
    colorsList: [],
    filter: {
      x: 200,
      y: wardrobeHeight,
      z: 66,
    },
    activeMat: wardrobesConfigs[0].safo ? wardrobesConfigs[0].safo : null,
  });

  const [value, setValue] = useState(1);

  const { setPrice } = useContext(PriceContext);

  const openPopup = name => {
    const popup = document.querySelector(`[data-popup-name="${name}"]`);
    if (!!popup) {
      popup.classList.add('open');
    }
  };

  const submitItemToBrw = async () => {
    const bodyFromCanvas = await getImageFromCanvas();

    openPopup('show-basket');
    sendDataToExternalBasketOne(bodyState.activeMat, value, 3, bodyFromCanvas).then(response => {
      submitAjaxToBrw(response.data.result.order).then(response => {
        // 1 - jeśli jest wszystko OK
        if (response.data.status === 1) {
        }
      });
    });
  };

  const setFilter = (value, index) => {
    let color, filter;
    const wardrobe = wardrobesConfigs[activeWardrobe];

    if (index === 'color') {
      color = value.split('-').pop();
      filter = { ...bodyState.filter };
    } else {
      color = bodyState.activeMat.split('-').pop();
      filter = {
        ...bodyState.filter,
        [index]: value,
      };
    }

    let filteredData = [...wardrobeHulls];

    filteredData = filteredData
      .filter(item => {
        return (
          item.dimensions.x === filter.x &&
          item.dimensions.y === filter.y &&
          item.dimensions.z === filter.z
        );
      })
      .sort((a, b) => {
        return a.safo.localeCompare(b.safo);
      });

    let newActiveMat = filteredData.find(item => {
      return item.safo.split('-').pop() === color;
    });

    if (newActiveMat !== undefined) {
      setBodyState({
        ...bodyState,
        filter: filter,
        activeMat: newActiveMat.safo,
        colorsList: filteredData,
      });

      newActiveMat = {
        ...newActiveMat,
        accessories: wardrobe.accessories,
        handles: wardrobe.handles,
        fronts: wardrobe.fronts,
        defaultFronts: wardrobe.defaultFronts,
        brake: wardrobe.brake,
      };

      newActiveMat.defaultFronts = defaultFront[newActiveMat.is_hinged ? 8 : 7];
      wardrobesConfigs[activeWardrobe] = newActiveMat;
      setWardrobesConfigs(wardrobesConfigs);
    }
    setPrice(calculatePrice(wardrobesConfigs[0]));
  };

  const setDepthInternal = value => {
    setFilter(value, 'z');
  };

  const setWidthInternal = value => {
    setFilter(value[0], 'x');
  };

  const setMaterial = value => {
    setFilter(value.safo, 'color');
  };
  const setHeightInternal = value => {
    setWardrobeHeight(value);
    setFilter(value, 'y');
  };

  let depthArr = [];
  const { dimensions, slidePoints } = props;
  if (dimensions) {
    depthArr = Object.keys(dimensions.depth).map(item => dimensions.depth[item]);
  }

  useEffect(() => {
    const wardrobe = wardrobesConfigs[activeWardrobe];

    if (bodyState.colorsList.length === 0) {
      let colorsList = [...wardrobeHulls];
      colorsList = colorsList
        .filter(item => {
          return (
            item.dimensions.z === bodyState.filter.z &&
            item.dimensions.y === bodyState.filter.y &&
            item.dimensions.x === bodyState.filter.x
          );
        })
        .sort((a, b) => {
          return a.safo.localeCompare(b.safo);
        });

      setBodyState({
        ...bodyState,
        activeMat: wardrobe.safo,
        filter: wardrobe.dimensions,
        colorsList: colorsList,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wardrobeHulls]);

  const cntWardrobes = wardrobesConfigs.length === 1;

  return (
    <>
      <div className="container wardrobe-config">
        {dimensions && cntWardrobes && (
          <>
            <SelectionButtons
              title="Głębokość szafy:"
              params={depthArr}
              unit="cm"
              selectionGroupName="wardrobe-depth"
              setValue={setDepthInternal}
              activeValue={bodyState.filter.z}
            />
            <SelectionButtons
              title="Wysokość szafy"
              params={dimensions.height}
              unit="cm"
              selectionGroupName="wardrobe-depth"
              setValue={setHeightInternal}
              activeValue={wardrobeHeight}
            />
          </>
        )}
        <RangeSlider
          slidePoints={slidePoints}
          sliderName="Szerokość:"
          activeValue={bodyState.filter.x}
          unit="cm"
          changeSize={setWidthInternal}
          wardrobesConfigs={wardrobesConfigs}
          activeWardrobe={activeWardrobe}
        />
        <ColorListBox
          title={`Kolor korpusu:  ${wardrobesConfigs[activeWardrobe].name}`}
          activeValue={bodyState.activeMat}
          changeMaterial={setMaterial}
          colorsList={bodyState.colorsList}
          propClass="color-list--margin-bottom"
        />
        <div className="buy-wardrobe-counter">
          <p className="buy-wardrobe-head">Ilość:</p>
          <div className="buy-wardrobe--flex">
            <button
              className="buy-accessories__counter-button"
              onClick={value <= 1 ? null : () => setValue(value - 1)}>
              -
            </button>
            <p className="buy-wardrobe-text">{value}</p>
            <button className="buy-accessories__counter-button" onClick={() => setValue(value + 1)}>
              +
            </button>
          </div>
        </div>
        <SummaryBar btnText="Do Koszyka" btnFunction={submitItemToBrw} btnIcon={true} />
      </div>
      <PopUp title=" " popupName={`show-basket`} noButton>
        <ShowBasketPopup />
      </PopUp>
    </>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    sendDataToExternalBasketOne: (item, value, mode, bodyFromCanvas) => {
      return dispatch(sendDataToExternalBasketOne(item, value, mode, bodyFromCanvas));
    },
    submitAjaxToBrw: payload => {
      return dispatch(submitAjaxToBrw(payload));
    },
  };
};

const mapStateToProps = state => {
  return {
    wardrobeHulls: state.products.wardrobeHulls,
    dimensions: state.dimensions.dimensions,
    defaultFront: state.defaults.front,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyWardrobeBodyConfigs);
